import { teamRoles } from "../../../../../constants/teamRoles";

import getProductionTeamMembersByRole from "../getProductionTeamMembersByRole";

export default function getProductionManagers({ production }) {
	return getProductionTeamMembersByRole({ production, role: teamRoles.MANAGER });
}
